(function () {
  'use strict';

  var SELECTED_CLASS = 'is-selected';
  var CARD_SELECTED_CLASS = 'is-gift-selected';
  var ADDED_LABEL = 'Added ✓';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.js-free-gift-add'));
    if (!buttons.length) return;

    var picker = document.querySelector('.js-free-gift-picker');
    var onAddBehavior = (picker && picker.getAttribute('data-on-add')) || 'redirect';

    function setButtonState(button, selected) {
      var label = button.querySelector('.js-free-gift-add-label');
      button.classList.toggle(SELECTED_CLASS, selected);
      if (label) {
        // Capture the merchant-configured label (from the section setting)
        // the first time we touch this button, so deselecting restores the
        // real configured text rather than a hardcoded string.
        if (!label.dataset.defaultLabel) label.dataset.defaultLabel = label.textContent;
        label.textContent = selected ? ADDED_LABEL : label.dataset.defaultLabel;
      }

      // Beyond the button label, give the whole tile a glowing outline while
      // selected - a clearer at-a-glance cue than the button text alone,
      // especially once other tiles are on the page too. The actual glow
      // (colour, blur, transition) is defined as real CSS in
      // free-gift-picker.liquid, driven by the section's colour setting -
      // this just toggles the class that CSS keys off.
      var card = button.closest('.js-free-gift-card');
      if (card) card.classList.toggle(CARD_SELECTED_CLASS, selected);
    }

    function setBusy(button, busy) {
      button.disabled = busy;
      button.classList.toggle('opacity-50', busy);
      button.classList.toggle('pointer-events-none', busy);
    }

    // On load, mark whichever of our gift variants (if any) is already in cart.
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cartVariantIds = cart.items.map(function (item) { return String(item.variant_id); });
        buttons.forEach(function (button) {
          var variantId = button.getAttribute('data-variant-id');
          if (variantId && cartVariantIds.indexOf(variantId) !== -1) {
            setButtonState(button, true);
          }
        });
      })
      .catch(function () { /* non-critical: leave buttons in default state */ });

    function removeVariant(variantId) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 }),
      });
    }

    function addVariant(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        var alreadySelected = button.classList.contains(SELECTED_CLASS);
        var otherSelected = buttons.filter(function (b) {
          return b !== button && b.classList.contains(SELECTED_CLASS);
        });

        buttons.forEach(function (b) { setBusy(b, true); });

        var chain = Promise.resolve();
        otherSelected.forEach(function (b) {
          var otherVariantId = b.getAttribute('data-variant-id');
          chain = chain.then(function () { return removeVariant(otherVariantId); });
        });

        if (alreadySelected) {
          chain = chain.then(function () { return removeVariant(variantId); });
        } else {
          chain = chain.then(function () { return addVariant(variantId); });
        }

        chain
          .then(function () {
            if (!alreadySelected) {
              // The theme's mini-cart drawer is a client-side (Preact)
              // component that only fetches cart data once on mount, not on
              // every open — since we add via a plain fetch() outside its
              // normal flow, it never learns the cart changed and shows
              // stale (or, worse, a stuck loading state). Redirecting to (or
              // reloading) the cart page sidesteps that entirely; "remain"
              // trades that fix away for staying on the picker, so the
              // mini-cart may still be stale until the merchant's next full
              // navigation - that trade-off is a config choice, not a bug.
              if (onAddBehavior === 'redirect') {
                window.location.href = '/cart';
                return;
              }
              if (onAddBehavior === 'reload') {
                window.location.reload();
                return;
              }
              // 'remain': stay on the page and just reflect the selection.
              otherSelected.forEach(function (b) { setButtonState(b, false); });
              setButtonState(button, true);
              buttons.forEach(function (b) { setBusy(b, false); });
              return;
            }
            otherSelected.forEach(function (b) { setButtonState(b, false); });
            setButtonState(button, false);
            buttons.forEach(function (b) { setBusy(b, false); });
          })
          .catch(function () {
            buttons.forEach(function (b) { setBusy(b, false); });
          });
      });
    });
  });
})();
